import { FieldErrors, FieldValues, UseFormReturn } from 'react-hook-form'

export type FormValidateResult<T extends FieldValues> =
  | { success: true; data: T }
  | { success: false; errors: FieldErrors<T> }

function validateWithHandleSubmit<TValues extends FieldValues>(
  form: UseFormReturn<TValues>,
): Promise<FormValidateResult<TValues>> {
  const { handleSubmit } = form

  return new Promise<FormValidateResult<TValues>>((resolve) => {
    handleSubmit(
      (data) => {
        resolve({ success: true, data })
      },
      (errors) => {
        resolve({ success: false, errors })
      },
    )()
  })
}

export default validateWithHandleSubmit
